import { reactive, h } from 'vue';

/**
 * Minimal replacement for vue-mq's $mq global (sm / md / lg), matching the
 * breakpoints previously configured in main.js: sm < 768 <= md < 1200 <= lg.
 */
const state = reactive({ mq: 'lg' });

const compute = () => {
  const w = window.innerWidth;
  state.mq = w < 768 ? 'sm' : w < 1200 ? 'md' : 'lg';
};

const ORDER = ['sm', 'md', 'lg'];

/**
 * Replacement for vue-mq's `mq` filter (filters were removed in Vue 3):
 * returns the map value for the current breakpoint, falling back to the
 * nearest smaller defined one.
 */
const pick = map => {
  const idx = ORDER.indexOf(state.mq);
  for (let i = idx; i >= 0; i--) {
    if (map[ORDER[i]] !== undefined) {
      return map[ORDER[i]];
    }
  }
  return undefined;
};

/**
 * vue-mq's <mq-layout> equivalent: renders its slot only when the current
 * breakpoint matches `mq` ("sm", "md", "lg", "md+" for md-and-up, or an
 * array of names). Without this the mobile/desktop variants both render.
 */
const MqLayout = {
  name: 'MqLayout',
  props: {
    mq: { type: [String, Array], required: true },
    tag: { type: String, default: 'div' }
  },
  computed: {
    isVisible() {
      const current = ORDER.indexOf(state.mq);
      const wanted = Array.isArray(this.mq) ? this.mq : [this.mq];
      return wanted.some(name => {
        if (name.endsWith('+')) {
          return current >= ORDER.indexOf(name.slice(0, -1));
        }
        return name === state.mq;
      });
    }
  },
  render() {
    return this.isVisible
      ? h(
          this.tag,
          this.$attrs,
          this.$slots.default ? this.$slots.default() : []
        )
      : null;
  }
};

export default {
  install(app) {
    compute();
    window.addEventListener('resize', compute);
    Object.defineProperty(app.config.globalProperties, '$mq', {
      get: () => state.mq
    });
    app.config.globalProperties.$mqPick = pick;
    app.component('MqLayout', MqLayout);
  }
};
